import { useMemo } from 'react';
import { useGetSuppliersQuery } from '@/lib/api/lookupsApi';
import { useModuleLookups } from '@/hooks';
import { buildLookupOptions } from '@/config/formOptions';
import { EMPTY_LIST } from '@/lib/utils';

// Everything the Add/Edit shipment form needs from the server, in one call.
export const useShipmentFormOptions = () => {
  const { certificateType, sites, materials, facilityOptions, materialsLoading } =
    useModuleLookups();
  const { data: suppliers = EMPTY_LIST, isLoading: suppliersLoading } = useGetSuppliersQuery();

  const options = useMemo(
    () => ({
      facilities: facilityOptions,
      suppliers: buildLookupOptions(suppliers),
      sites,
      materials,
      certificateType,
    }),
    [facilityOptions, suppliers, sites, materials, certificateType],
  );

  return {
    options,
    materials,
    isLoading: materialsLoading || suppliersLoading,
  };
};
